import React from "react";
import { appColors, farmerInviteStatus } from "../../utils/constants";

const FarmerInviteStatusButton = ({
  status = farmerInviteStatus["pending"],
  barHeight = "",
}) => {
  const handleBGColor = (status) => {
    switch (status) {
      case farmerInviteStatus["pending"]:
        return appColors.primaryYellow;
      case farmerInviteStatus["accepted"]:
        return appColors.secondaryGreen;
      case farmerInviteStatus["rejected"]:
        return appColors.secondaryRed;
      default:
        return appColors.primaryGray;
    }
  };

  return (
    <div
      className={`text-center text-white font-semibold shadow my-2 w-32 rounded-md ${barHeight} ${handleBGColor(
        status
      )}`}
      style={{
        opacity: 0.7,
        backgroundColor: handleBGColor(status),
      }}
    >
      {status.slice(0, 1).toUpperCase() + status.slice(1)}
    </div>
  );
};

export default FarmerInviteStatusButton;
